<template>
  <p class="checked-box fc" @click="handleSelectAll" data-testid="components-formitem-botcheckbox-select-all">
    <svg-icon
      v-if="modelValue && !indeterminate"
      name="checked"
      :padding="0"
      color="var(--theme-color)"
    />
    <u-checkbox v-if="!modelValue && indeterminate" indeterminate />
    <span v-if="!modelValue && !indeterminate" class="not-checked" />
    <span v-if="label" class="label">{{ label }}</span>
  </p>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const handleSelectAll = () => {
      emit('update:modelValue', !props.modelValue);
      emit('change', !props.modelValue);
    };
    return {
      handleSelectAll
    };
  }
});
</script>

<style scoped lang="less">
.checked-box {
  display: inline-flex;
  cursor: pointer;
  height: 20px;
  &:hover {
    color: var(--active-font-color);
    .not-checked {
      border-color: var(--theme-color);
    }
  }
  .label {
    margin-left: 6px;
  }
}

.not-checked {
  width: 16px;
  height: 16px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid var(--border-neutral-color-secondary);
}
</style>
